import React, { useState } from 'react';

import _ from 'lodash';
import styled from 'styled-components';

import { paginate } from '../../utils/lib';

const ListItem = styled.li`
    list-style: none;
`;

const PaginationButton = styled.button`
    background-color: ${(props) => props.$isActive ? '#dddddd' : 'transparent'};
    color: ${(props) => props.$isActive ? '#000000' : 'gray'};
    border: none;
    border-radius: 0.19rem;
    margin-right: 1rem;
    min-width: 1.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    min-height: 1.5rem;
    opacity: 0.5;
    cursor: pointer;
`;

const Pagination = ({ currentPage, itemsCount, pageSize, onPageChange }) => {
    const [currentIndex, setCurrentIndex] = useState(1);

    const pagesCount = Math.ceil(itemsCount / pageSize);
    if (pagesCount <= 1) return null;
  
    const pages = _.range(1, pagesCount + 1);
    const totalIndex = Math.ceil(pages.length / 3);
    const pagesToDisplay = paginate(pages, currentIndex, 3);
   
	return (
		<nav>
			<ul className='d-flex justify-content-center align-items-center'>
                {currentIndex > 1 && (
                    <ListItem>
                        <PaginationButton onClick={() => setCurrentIndex(currentIndex - 1)}>
                            <i className="mdi mdi-chevron-double-left"></i>
                        </PaginationButton>
                    </ListItem>
                )}

				{pagesToDisplay.map((page) => (
                    <ListItem key={page}>
                        <PaginationButton $isActive={page === currentPage} onClick={() => onPageChange(page)}>
                            {page}
                        </PaginationButton>
                    </ListItem>
				))}

                {currentIndex < totalIndex && (
                    <ListItem>
                        <PaginationButton onClick={() => setCurrentIndex(currentIndex + 1)}>
                            <i className="mdi mdi-chevron-double-right"></i>
                        </PaginationButton>
                    </ListItem>
                )}
			</ul>
		</nav>
	);
};

export default Pagination;
